import React from 'react';
import { Info } from 'lucide-react';
interface FirstPackHeldBannerProps {
  message: string;
}
export function FirstPackHeldBanner({
  message
}: FirstPackHeldBannerProps) {
  return <div role="status" className="flex items-start gap-3 border-l-4 border-[#0EA5E9] bg-[#E0F2FE] rounded-lg p-4 mb-6" data-id="element-4903" data-mp="18bdjyrlkfmt4">
      <Info className="w-5 h-5 text-[#0EA5E9] flex-shrink-0 mt-0.5" data-id="element-4904" data-mp="13dc0w6o53nhn" />
      <p className="text-[14px] font-medium text-[#0369A1]" data-id="element-4905" data-mp="ydfyucz0664q">{message}</p>
    </div>;
}